export const EMAIL = 'EMAIL';
export const PHONE = 'PHONE';
export const URL = 'URL';

const CONTACT_TYPES = [EMAIL, PHONE, URL];

export default CONTACT_TYPES;
